export function checkForCompleated(json) {
  //find each item in json and check if it is compleated if all are compleated then return true else return false
  let checkForCompleated = true;
  json.forEach((item) => {
    if (!item.isCompleted) {
      checkForCompleated = false;
    }
  });
  return checkForCompleated;
}
